import { type IUserPermissions } from "utilities/list/list.types";

export enum SelectionListContainerTabs {
    Default = -1,
    // Agenda = 0, -- Removed by ADO-268881
    CardView = 1,
    List = 2,
    Hierarchy = 3,
    Category = 4,
    Location = 5,
    Allowances = 6,
    Favorites = 7,
    SubSelections = 8,
    /** New Selections gallery view; route-only, never a stored default tab. */
    Gallery = 9,
}

export interface ISelectionConfigApiData {
    defaultBuilderTab: SelectionListContainerTabs;
    defaultOwnerTab: SelectionListContainerTabs;
    jobIncludesAllowances: boolean;
    ownerCanViewLockedSelections: boolean;
    selectionPermissions: IUserPermissions;
    shouldExpandCategoryLocationGroups: boolean;
    isSelectionsReimaginedJob: boolean;
    newJobsUseSelectionsReimagined: boolean;
}

export class SelectionConfig {
    constructor(data: ISelectionConfigApiData) {
        this.defaultBuilderTab = data.defaultBuilderTab;
        this.defaultOwnerTab = data.defaultOwnerTab;
        this.jobIncludesAllowances = data.jobIncludesAllowances;
        this.ownerCanViewLockedSelections = data.ownerCanViewLockedSelections;
        this.selectionPermissions = data.selectionPermissions;
        this.shouldExpandCategoryLocationGroups = data.shouldExpandCategoryLocationGroups;
        this.isSelectionsReimaginedJob = data.isSelectionsReimaginedJob;
        this.newJobsUseSelectionsReimagined = data.newJobsUseSelectionsReimagined;
    }
    defaultBuilderTab: SelectionListContainerTabs;
    defaultOwnerTab: SelectionListContainerTabs;
    jobIncludesAllowances: boolean;
    ownerCanViewLockedSelections: boolean;
    selectionPermissions: IUserPermissions;
    shouldExpandCategoryLocationGroups: boolean;
    isSelectionsReimaginedJob: boolean;
    /** The builder's setting to put every new job on the new selections experience */
    newJobsUseSelectionsReimagined: boolean;
}
